import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";
import { useUserContext } from "../../../context/UserContext";
import { hasRole } from "../../../lib/auth";
import { ROUTES, signInPath } from "../../../route_paths";

interface UseExpertInsightsAuthResult {
  session: Session | null;
  signOut: () => Promise<void>;
}

/**
 * Auth guard for /expert-insights/* routes.
 * Redirects to /expert-insights/login if there is no active session or the user
 * does not hold the expert_insights.expert role.
 */
export function useExpertInsightsAuth(): UseExpertInsightsAuthResult {
  const { session, loading, signOut } = useUserContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!session || !hasRole(session.user, "expert_insights.expert")) {
      navigate(signInPath(ROUTES.expertInsights.insights.path()), { replace: true });
    }
  }, [session, loading, navigate]);

  return { session, signOut };
}
